import type { RouteConfig } from 'vue-router/types/router';

const routes: RouteConfig[] = [
    {
        path: '/libraries',
        component: () => import(/* webpackChunkName: "libraries" */ '@/components/EmptyWrapper.vue'),
        children: [
            {
                path: '',
                name: 'Libraries',
                component: () => import(/* webpackChunkName: "libraries" */ '@/views/Libraries/Main.vue')
            },
            {
                path: 'details/:libraryId',
                name: 'LibraryDetails',
                props: true,
                component: () => import(/* webpackChunkName: "libraries" */ '@/views/Libraries/LibraryDetails.vue')
            },
            {
                path: 'details/:libraryId/category/:categoryId/elements',
                name: 'LibraryCategory',
                props: true,
                component: () => import(/* webpackChunkName: "libraries" */ '@/views/Libraries/LibraryDetails.vue')
            }
        ]
    }
];

export default routes;
